<!-- SPEC-2311: The commented lined are because of a sorting 'bug' where the DragIndex does not match
the item's order property, because of deleted/hidden items in the list. To fix this, every item is 
added to the list, but has a style of display: none. When this does not fix the issue, reactivate
the hidden lines again (cleaner code). -->

<div class="toolbar">
  {{ 'navigation' | translate }}
</div>
<div #index class="project-info tree">

  <!-- Module -->
  <div class="modules" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="orderModules($event)" [class.hide-submodules]="(this.projectInfoService.view$ | async)._id === 2">
    <ng-container *ngFor="let module of moduleService.module$ | async | pveFilter">
      <div *ngIf="module.active && !module.hide" class="module" cdkDrag cdkDragBoundary=".modules" [cdkDragData]="module">
        <div class="item">
          <span class="handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
          <span class="title" (click)="scrollTo(module)">
            <span class="chapter">{{ module.chapter }}.</span> {{ module.name }}
          </span>
          <sg2-module-options 
            *ngIf= "authService.canRead('element-contextmenu')"
            class="options"
            [module]="module"
            [options]="['addSubmodule', 'assignTo', 'delete', 'setStatus']">
          </sg2-module-options>
        </div>

        <!-- Submodule -->
        <div class="submodules" cdkDropList cdkDropListLockAxis="y" (cdkDropListDropped)="orderSubmodules($event)">
          <ng-container *ngFor="let submodule of module.submodules">
            <div *ngIf="submodule.active" class="submodule" cdkDrag cdkDragBoundary=".submodules" [cdkDragData]="submodule">
              <div class="item">
                <span class="handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
                <span class="title" (click)="scrollTo(submodule)">
                  <span class="chapter" *ngIf="submodule.chapter">{{ submodule.chapter }}.</span> {{ submodule.name }}
                </span>
                <sg2-submodule-options 
                  *ngIf= "authService.canRead('element-contextmenu')"
                  class="options"
                  [submodule]="submodule"
                  [options]="['addElement', 'assignTo', 'delete', 'setStatus']">
                </sg2-submodule-options>
              </div>

              <!-- Element -->
              <div class="elements" [id]="'element-droplist-' + submodule._id" cdkDropList [cdkDropListConnectedTo]="elementDropListIds" cdkDropListLockAxis="y" (cdkDropListDropped)="orderElements($event)">
                <ng-container *ngFor="let element of submodule.elements">
                  <div *ngIf="element.active" class="element" cdkDrag [cdkDragData]="element" [id]="'index-' + element._id">
                    <div class="item">
                      <span class="handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
                      <span class="title" (click)="scrollTo(element)">
                        <span class="bullet" [style.color]="elementService.getStatusColor(element)">&#9679;</span>
                        <span class="chapter" *ngIf="element.chapter">{{ element.chapter }}.</span>
                        <span>{{ element.name }}</span>
                      </span>
                      <sg2-element-options 
                        *ngIf= "authService.canRead('element-contextmenu')"
                        class="options"
                        [element]="element"
                        [options]="['assignTo', 'delete', 'edit', 'restoreParagraph', 'setStatus', 'showLogs']">
                      </sg2-element-options>
                    </div>
                  </div>
                </ng-container>
              </div>

            </div>

            <!-- Submodule placeholder -->
            <!-- Important for Drag-and-drop, needed for correct order of submodules. -->
            <!-- @todo Shows name for testing purposes, cleanup. -->
            <div *ngIf="!submodule.active" class="submodule placeholder" cdkDrag cdkDragBoundary=".submodules" [cdkDragData]="submodule">
              <!-- <div class="item">
                <span class="handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
                <span class="title" style="color: red;">
                  <em><span class="chapter">X.X.</span>{{ submodule.name }}</em>
                </span>
              </div> -->
              <div class="item">
                <span class="handle hidden" cdkDragHandle></span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Module placeholder -->
      <!-- Important for Drag-and-drop, needed for correct order of modules. -->
      <!-- @todo Shows name for testing purposes, cleanup. -->
      <div *ngIf="!module.active || module.hide" class="module placeholder" cdkDrag cdkDragBoundary=".modules" [cdkDragData]="module">
        <!-- <div class="item">
          <span class="handle" cdkDragHandle><mat-icon>drag_indicator</mat-icon></span>
          <span class="title" style="color: red;">
            <em><span class="chapter">X.</span>{{ module.name }}</em>
          </span>
        </div> -->
        <div class="item">
          <span class="handle hidden" cdkDragHandle></span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- <ng-template #modulePlaceholder>
  <div cdkDrag cdkDragBoundary=".modules" [cdkDragData]="{ }"></div>
</ng-template> -->

<!-- <ng-template #submodulePlaceholder>
  <div cdkDrag cdkDragBoundary=".submodules" [cdkDragData]="{ }"></div>
</ng-template> -->
